
import { NavigationStore } from "@/store/navigation";
import { Component, Vue } from "vue-property-decorator";

@Component({})
export default class AppContinueShippingBanner extends Vue {
  NavigationStore: any = NavigationStore;
}
